export default __webpack_public_path__ + "static/media/bx-github.1ae687a7.svg";